var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.035 2.977V1.535M5.04 5.043L4.021 4.024M2.977 10.035H1.535M5.04 15.023l-1.019 1.019M15.023 15.023l1.02 1.019M17.094 10.035h1.441M15.023 5.043l1.02-1.019M11.804 18.463a6.579 6.579 0 011.984-4.66 5.319 5.319 0 10-7.549-.053 6.775 6.775 0 012.023 4.713h3.542zM8.324 21.073l3.48-.798M8.324 22.716l3.48-.803",
    stroke: "#515864",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgLightBulb;